import { render, staticRenderFns } from "./OfferingDetail.vue?vue&type=template&id=c39d9b7c&scoped=true&"
import script from "./OfferingDetail.vue?vue&type=script&lang=ts&"
export * from "./OfferingDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OfferingDetail.vue?vue&type=style&index=0&id=c39d9b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39d9b7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VLayout,VRow})
